import React, { Component } from "react";
import "./styles.css";
import { apiEmployee } from "../../services/apiamrg";
import Header from "../../components/header";
import { connect } from "react-redux";
import { Link, Redirect } from "react-router-dom";
import moment from "moment";
import Select from "react-select";
import "react-confirm-alert/src/react-confirm-alert.css";
import { Squares } from "react-activity";
import {
  faArrowLeft,
  faCheckCircle,
  faCopy,
} from "@fortawesome/free-solid-svg-icons";
import Util from "../../classes/util";
import ModalProdutos from "../../components/modalProdutos";
import QRCode from "react-qr-code";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ListaProdutos from "../../components/listaProdutos";
import { CHAVE_PIX, EMPRESA_CNPJ } from "../../config";

const estadoInicial = {
  chave: 0,
  voucher: {},

  unidade: 0,
  Chave: 0,
  DataChegada: "",
  DataSaida: "",
  Data: "",
  DataCombinada: "",
  Conclusao: "",
  Defeito: "",

  Situacao: "",
  Cliente: "",
  Operador: "",
  Chave_Equipamento: "",
  valorTotal: 0,

  meioPagamento: 0,

  situacoesOptions: [],
  clientesOptions: [],
  unidadesOptions: [],
  meiosPagamentosOptions: [
    { label: "Pix", value: 0 },
    { label: "Boleto", value: 1 },
  ],
  produtos: [],
  produtosEscolhidos: [],

  textOptions: "",

  produtosModal: false,
  pagamentoFinalizado: false,

  qrCode: "",
  barCode: "",

  loading: false,
  redirect: false,
};

class AddPedido extends Component {
  state = {
    ...estadoInicial,
    Operador: this.props.id,
  };

  componentDidMount = async () => {
    const { id } = this.props.match?.params;
    const chave = Number(id);
    this.setState({ chave: chave });

    if (id != 0) {
      this.loadPedido(id);
    }

    this.loadAll();
  };

  loadPedido = async (id) => {
    apiEmployee
      .get(`tickets/detalhaTicketCredito/${id}`)
      .then(async (res) => {
        const response = res.data;
        if (response[0]) {
          this.setState({ unidade: response[0]?.chave_unidade });

          await this.alteraUnidade(response[0]?.chave_unidade);

          const produtosEscolhidos = [];
          if (response[0]?.produto) {
            response.forEach((e) => {
              produtosEscolhidos.push({
                ...this.state.produtos.find((p) => p.chave == e.produto),
                quantidade: e.quantidade,
                chave_item: e.chave_item,
              });
            });
          }

          this.setState({ produtosEscolhidos });
          this.setState({
            valorTotal: Number(this.props?.location?.state?.ticket?.saldo || 0),
          });
        }
      })
      .catch((err) => console.error(err));
  };

  loadAll = async () => {
    const situacoesOptions = await apiEmployee
      .get(`pegarsituacoes`)
      .then((res) => res.data)
      .catch((err) => []);
    const unidadesOptions = await apiEmployee
      .get(`pegarunidades`)
      .then((res) => res.data)
      .catch((err) => []);

    await this.setState({
      situacoesOptions: [
        { label: "---", value: "" },
        ...situacoesOptions.map((s) => ({
          label: s.Descricao,
          value: s.Chave,
        })),
      ],
      unidadesOptions: [
        { label: "---", value: "" },
        ...unidadesOptions.map((b) => ({ label: b.Nome, value: b.Chave })),
      ],
    });
  };

  alteraUnidade = async (unidade) => {
    const produtos = await apiEmployee
      .get(`pegarprodutosunidades/${unidade}`)
      .then((res) => res.data)
      .catch((err) => []);
    this.setState({ produtos, valorTotal: 0 });
  };

  payPedido = async () => {
    if (this.state.chave == 0) {
      if (this.state.meioPagamento == 0) {
        const pixPayload = {
          expiracao: 3600,
          devedor_cnpj: this.props.cnpj_cpf,
          devedor_nome: this.props.nome,
          valor: this.state.valorTotal.toFixed(2),
          chave_pix: CHAVE_PIX,
          cnpj: EMPRESA_CNPJ,
        };

        const ticketPayload = {
          empresa: this.props.empresa,
          data: moment().format("YYYY-MM-DD"),
          chave_pessoa: this.props.id,
          valor: this.state.valorTotal,
          saldo: this.state.valorTotal,
          status: 1,
          chave_unidade: this.state.unidade,
          meio_pagamento: this.state.meioPagamento,
        };

        const ticketCreditosItens = [];
        this.state.produtosEscolhidos.forEach((prod) => {
          ticketCreditosItens.push({
            chave_produto: prod.chave,
            quantidade: prod.quantidade,
            valor_unitario: prod.preco,
            valor_total: prod.preco * prod.quantidade,
          });
        });

        const pixReturn = await apiEmployee
          .post(`tickets/salvarTicketCredito`, {
            pixPayload,
            ticketPayload,
            ticketCreditosItens,
          })
          .then(
            (res) => res.data,
            (err) => alert(`{msg: "Houve um erro, tente novamente mais tarde"}`)
          );

        if (pixReturn) {
          await this.setState({
            chave: pixReturn?.chave_ticket,
            qrCode: pixReturn?.qrCode,
            barCode: pixReturn?.qrCode,
            txId: pixReturn?.txid,
          });
          this.checarPagamento();
        }
      }
    } else {
      if (this.state.meioPagamento == 0) {
        const pixPayload = {
          expiracao: 3600,
          devedor_cnpj: this.props.cnpj_cpf,
          devedor_nome: this.props.nome,
          valor: this.state.valorTotal.toFixed(2),
          chave_pix: CHAVE_PIX,
          cnpj: EMPRESA_CNPJ,
        };

        const ticketPayload = {
          valor: this.state.valorTotal,
          saldo: this.state.valorTotal,
          status: 1,
          chave_unidade: this.state.unidade,
          meio_pagamento: this.state.meioPagamento,
        };

        const ticketCreditosItens = [];
        this.state.produtosEscolhidos.forEach((prod) => {
          ticketCreditosItens.push({
            chave_ticket: this.state.chave,
            chave_item: prod.chave_item,
            chave_produto: prod.chave,
            quantidade: prod.quantidade,
            valor_unitario: prod.preco,
            valor_total: prod.preco * prod.quantidade,
          });
        });

        const pixReturn = await apiEmployee.put(
          `tickets/editarTicketCredito/${this.state.chave}`,
          {
            pixPayload,
            ticketPayload,
            ticketCreditosItens,
          }
        );

        this.setState({
          qrCode: pixReturn?.data?.qrCode,
          barCode: pixReturn?.data?.qrCode,
          txId: pixReturn?.data?.txid,
        });
        this.checarPagamento();
      }
    }
  };

  savePedido = async () => {
    if (this.props.id !== 999999) {
      if (this.state.chave == 0) {
        const ticketPayload = {
          empresa: this.props.empresa,
          data: moment().format("YYYY-MM-DD"),
          chave_pessoa: this.props.id,
          valor: this.state.valorTotal,
          saldo: this.state.valorTotal,
          status: 0,
          chave_unidade: this.state.unidade,
          meio_pagamento: this.state.meioPagamento,
        };

        const ticketCreditosItens = [];
        this.state.produtosEscolhidos.forEach((prod) => {
          ticketCreditosItens.push({
            chave_produto: prod.chave,
            quantidade: prod.quantidade,
            valor_unitario: prod.preco,
            valor_total: prod.preco * prod.quantidade,
            disponivel: prod.quantidade,
          });
        });

        const saveReturn = await apiEmployee.post(`tickets/salvarTicketCredito`, {
          ticketPayload,
          ticketCreditosItens,
        });

        this.setState({ chave: saveReturn.chave_ticket, redirect: true });
      } else {
        const ticketPayload = {
          valor: this.state.valorTotal,
          saldo: this.state.valorTotal,
          status: 0,
          chave_unidade: this.state.unidade,
          meio_pagamento: this.state.meioPagamento,
        };

        const ticketCreditosItens = [];
        this.state.produtosEscolhidos.forEach((prod) => {
          ticketCreditosItens.push({
            chave_ticket: this.state.chave,
            chave_item: prod.chave_item,
            chave_produto: prod.chave,
            quantidade: prod.quantidade,
            valor_unitario: prod.preco,
            valor_total: prod.preco * prod.quantidade,
            disponivel: prod.quantidade,
          });
        });

        const saveReturn = await apiEmployee.put(
          `tickets/editarTicketCredito/${this.state.chave}`,
          {
            ticketPayload,
            ticketCreditosItens,
          }
        );

        this.setState({ redirect: true });
      }
    } else {
      if (this.state.chave == 0) {
        const ticketPayload = {
          empresa: localStorage.getItem('empresaID'),
          data: moment().format("YYYY-MM-DD"),
          chave_pessoa: this.props.id,
          valor: this.state.valorTotal,
          saldo: this.state.valorTotal,
          status: 0,
          chave_unidade: this.state.unidade,
          meio_pagamento: this.state.meioPagamento,
        };

        const ticketCreditosItens = [];
        this.state.produtosEscolhidos.forEach((prod) => {
          ticketCreditosItens.push({
            chave_produto: prod.chave,
            quantidade: prod.quantidade,
            valor_unitario: prod.preco,
            valor_total: prod.preco * prod.quantidade,
            disponivel: prod.quantidade,
          });
        });

        const saveReturn = await apiEmployee.post(`tickets/salvarTicketCredito`, {
          ticketPayload,
          ticketCreditosItens,
        });

        this.setState({ chave: saveReturn.chave_ticket, redirect: true });
      } else {
        const ticketPayload = {
          valor: this.state.valorTotal,
          saldo: this.state.valorTotal,
          status: 0,
          chave_unidade: this.state.unidade,
          meio_pagamento: this.state.meioPagamento,
        };

        const ticketCreditosItens = [];
        this.state.produtosEscolhidos.forEach((prod) => {
          ticketCreditosItens.push({
            chave_ticket: this.state.chave,
            chave_item: prod.chave_item,
            chave_produto: prod.chave,
            quantidade: prod.quantidade,
            valor_unitario: prod.preco,
            valor_total: prod.preco * prod.quantidade,
            disponivel: prod.quantidade,
          });
        });

        const saveReturn = await apiEmployee.put(
          `tickets/editarTicketCredito/${this.state.chave}`,
          {
            ticketPayload,
            ticketCreditosItens,
          }
        );

        this.setState({ redirect: true });
      }
    }
  };

  checarPagamento = async () => {
    setTimeout(async () => {
      await apiEmployee.get(`pix/checarpagamento/${this.state.txId}`).then(
        async (res) => {
          if (res.data?.status === "CONCLUIDA") {
            await apiEmployee
              .put(`tickets/finalizarTicketCredito/${this.state.chave}`)
              .then(
                async (res) => { },
                async (err) => console.error(err)
              );

            this.setState({ pagamentoFinalizado: true });
          } else {
            this.checarPagamento();
          }
        },
        async (err) => console.error(err)
      );
    }, 15000);
  };

  filterOptions = (item) => {
    if (!this.state.textOptions) {
      return true;
    }

    return (
      item?.label
        ?.toLowerCase()
        .indexOf(this.state.textOptions?.toLowerCase()) != -1
    );
  };

  render() {
    const validations = [];
    validations.push(
      this.state.ship_name && this.state.ship_name.trim().length >= 3
    );

    //o formulário só será válido se todas as validações forem verdadeiras, com este reduce implementado
    const validForm = validations.reduce((t, a) => t && a);

    return (
      <div
        className="page"
        style={
          this.state.pagamentoFinalizado || this.state.qrCode
            ? { height: "100svh", backgroundColor: "#DE3338" }
            : {}
        }
      >
        {this.state.redirect && <Redirect to={"/pedidos"} />}
        {this.state.createVoucher && (
          <Redirect
            to={{
              pathname: "/addvoucher/0",
              state: { unidade: this.state.unidade },
            }}
          />
        )}

        <Header
          voltarPedido={!this.state.qrCode}
          hideLogout={!!this.state.qrCode}
          simplify={this.state.qrCode || this.state.pagamentoFinalizado}
        />

        {this.state.pagamentoFinalizado && (
          <>
            <div className="titulo100">
              <span>Pagamento Finalizado</span>
            </div>
            <div className="finalizado_wrapper">
              <FontAwesomeIcon icon={faCheckCircle} size="8x" color="white" />
            </div>
            <div className="finalizado_confirma">
              <div className="finalizado_pergunta">Deseja criar voucher?</div>
              <div className="finalizado_buttons">
                <button
                  className="finalizado_sim"
                  onClick={() => this.setState({ createVoucher: true })}
                >
                  Sim
                </button>
                <button
                  className="finalizado_nao"
                  onClick={() => this.setState({ redirect: true })}
                >
                  Não
                </button>
              </div>
            </div>
          </>
        )}

        {this.state.qrCode && !this.state.pagamentoFinalizado && (
          <>
            <div className="titulo100">
              <span>Pagar por QRCode</span>
            </div>
            <div className="qrcode_wrapper">
              <QRCode
                className="qrcode"
                value={this.state.qrCode}
                fgColor="#DE3338"
              />
            </div>
            <div className="center_div">
              <div className="copy_field">
                <div className="copy_label">
                  <span>Chave copia e cola:</span>
                </div>
                <div className="copy_interactables">
                  <input
                    className="copy_input"
                    onClick={(e) => e.target.select()}
                    readOnly
                    value={this.state.barCode}
                  />
                  <button
                    className="copy_button"
                    onClick={() =>
                      navigator.clipboard.writeText(this.state.barCode)
                    }
                  >
                    <FontAwesomeIcon icon={faCopy} color={"#888888"} />
                  </button>
                </div>
              </div>
            </div>
          </>
        )}

        {!this.state.qrCode && !this.state.pagamentoFinalizado && (
          <>
            <div className="centrom">
              <div
                className={`col-sm-12 col-md-12 col-lg-9 col-xl-9 row ${!this.state.unidade
                  ? "containeralterarpedido"
                  : !this.state.produtosEscolhidos[0]
                    ? "containeralterarproduto"
                    : "containeralterarcardapio"
                  }`}
              >
                <Link to={{ pathname: `/pedidos` }} style={{ color: "#DE3338", size: "30px", margin: "10px" }}>X</Link>
                <div className="form_body">
                  <div className="col-12 contcard">
                    <span>Unidade *</span>

                    <Select
                      placeholder="Selecione a unidade"
                      value={this.state.unidadesOptions.find(
                        (opt) => opt.value === this.state.unidade
                      )}
                      options={this.state.unidadesOptions
                        .filter(this.filterOptions)
                        .splice(0, 25)}
                      onChange={(a) => {
                        this.setState({
                          unidade: a.value,
                          produtosEscolhidos: [],
                        });
                        this.alteraUnidade(a.value);
                      }}
                      onInputChange={(a) => this.setState({ textOptions: a })}
                    />
                    <span>Não Selecionado</span>
                  </div>
                  {!!this.state.unidade && (
                    <>
                      <div className="col-12 contcard">
                        <div className="botao_produtos">
                          <span>Produtos *</span>
                        </div>

                        <hr />
                        <ListaProdutos
                          onSubmit={(produtos) => {
                            let valor = 0;
                            produtos.map((p) => {
                              valor += p.preco * p.quantidade;
                            });
                            this.setState({
                              produtosEscolhidos: produtos,
                              valorTotal: valor,
                            });
                          }}
                          setProdutosEscolhidos={(produtos) =>
                            this.setState({ produtosEscolhidos: produtos })
                          }
                          setValorTotal={(valor) =>
                            this.setState({ valorTotal: valor })
                          }
                          produtos={this.state.produtos}
                          produtosEscolhidos={this.state.produtosEscolhidos}
                        />
                        <hr />
                        <div className="form_produtos_lista_item bold">
                          <div>Total</div>
                          <div>
                            R$ {Util.formatarDinheiro(this.state.valorTotal)}
                          </div>
                        </div>
                      </div>

                      {this.state.produtosEscolhidos[0] && (
                        <div className="col-12 contcard last_field">
                          <span>Meio de Pagamento *</span>

                          <Select
                            value={this.state.meiosPagamentosOptions.find(
                              (opt) => opt.value === this.state.meioPagamento
                            )}
                            options={this.state.meiosPagamentosOptions
                              .filter(this.filterOptions)
                              .splice(0, 25)}
                            onChange={(a) =>
                              this.setState({ meioPagamento: a.value })
                            }
                            onInputChange={(a) =>
                              this.setState({ textOptions: a })
                            }
                          />
                          <span>Não Selecionado</span>
                        </div>
                      )}

                      {this.state.produtosEscolhidos[0] && (
                        <div className="col-12 contvtt multiple_submits">
                          <button
                            type="button"
                            className="button_rascunho"
                            onClick={() => this.savePedido()}
                          >
                            Salvar Rascunho
                          </button>
                          <button
                            type="button"
                            className="button_salvar"
                            onClick={() => this.payPedido()}
                          >
                            {this.state.meioPagamento === 0
                              ? "Pagar agora"
                              : "Agendar pagamento"}
                          </button>

                          {this.state.loading && (
                            <Squares color={"black"} size={40} speed={0.5} />
                          )}
                        </div>
                      )}
                    </>
                  )}
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    );
  }
}

const mapStateToProps = ({ user, servidor }) => {
  return {
    token: user.token,
    id: user.id,
    cnpj_cpf: user.cnpj_cpf,
    nome: user.nome,
    empresa: user.empresa,
    online: servidor.online,
  };
};

export default connect(mapStateToProps, null)(AddPedido);
